import { lockScroll, unlockScroll } from '../../@helpers';
import Close from '../icons/Close';
import Info from '../icons/Info';
import React, { Component, Fragment } from 'react';
import './style.scss';
import './themed.scss';

class PopUp extends Component {
  state = {
    active: false
  }
  handleShowPopUp = () => {
    this.setState({
      active: true
    })
    lockScroll()
  }

  handleHidePopUp = () => {
    this.setState({
      active: false
    })
    unlockScroll()
  }

  render(){
    const { active } = this.state
    const { children } = this.props
    const role = "popup";

    return (
      <Fragment>
        <button className="button button-icon popup_trigger-open" onClick={this.handleShowPopUp} type="button" aria-label="Open this pop-up for more information"><Info /></button>
        <div className="popup_container" data-active={active}>
          <dialog role={role}>
            <span className="button_container"><button tabIndex={ active ? 0 : -1 } className="button button-icon popup_trigger-close" onClick={this.handleHidePopUp} type="button" aria-label="Close this pop-up"><Close /></button></span>
            { children }
          </dialog>
        </div>
      </Fragment>
    )
  }
}

export default PopUp
